/**
 * Resources Tour Configuration
 * Introduces users to the resource center
 */

import { TourDefinition } from './tour.types';

export const resourcesTour: TourDefinition = {
  id: 'resources-tour',
  name: 'Resource Center',
  page: '/resources',
  version: 3, // Updated with proper tab navigation
  nextTourId: 'appointments-tour', // Chain to appointments tour
  steps: [
    {
      id: 'resources-intro',
      targetSelector: '[data-tour="resources-header"]',
      title: 'Resource Center',
      description:
        'Access all your carrier documents, forms, training materials, and marketing assets in one organized place.',
      placement: 'bottom',
    },
    {
      id: 'resources-tabs',
      targetSelector: '[data-tour="resources-tabs"]',
      title: 'Resource Views',
      description:
        'Navigate between Browse to find resources, Favorites for quick access to your saved items, and Management to organize your uploads.',
      placement: 'bottom',
    },
    {
      id: 'browse-tab',
      targetSelector: '[data-tour="resources-tab-browse"]',
      title: 'Browse Resources',
      description:
        'Search and filter through all available carrier forms, documents, and training materials. Use categories and carriers to find what you need.',
      placement: 'bottom',
      onShow: () => {
        setTimeout(() => {
          const tab = document.querySelector('[data-tour="resources-tab-browse"]') as HTMLElement;
          if (tab) {
            tab.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
            tab.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true }));
            tab.click();
          }
        }, 50);
      },
    },
    {
      id: 'favorites-tab',
      targetSelector: '[data-tour="resources-tab-favorites"]',
      title: 'Your Favorites',
      description:
        'Save resources you use often by clicking the heart icon. Access them quickly from this tab.',
      placement: 'bottom',
      onShow: () => {
        setTimeout(() => {
          const tab = document.querySelector('[data-tour="resources-tab-favorites"]') as HTMLElement;
          if (tab) {
            tab.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
            tab.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true }));
            tab.click();
          }
        }, 50);
      },
    },
    {
      id: 'management-tab',
      targetSelector: '[data-tour="resources-tab-management"]',
      title: 'Resource Management',
      description:
        'Upload your own documents, edit resource details, and manage your personal or agency-wide resources here.',
      placement: 'bottom',
      onShow: () => {
        setTimeout(() => {
          const tab = document.querySelector('[data-tour="resources-tab-management"]') as HTMLElement;
          if (tab) {
            tab.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
            tab.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true }));
            tab.click();
          }
        }, 50);
      },
    },
  ],
};
